import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";

import WithOverlay from "../../popups/withOverlayHoc";
import {
  setLookActiveCategory,
  setLookOverlayOpened,
  setLookPageOpened,
  setLookStylePopup
} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
// import {ROUTES} from "../../../routes";
import LookStylePopupFeature from "./lookStylePopupFeature";
import {removeFromCart} from "../../../actions/actionFunctions";
import {setLookRemovedCartItems} from "../../../actions/shoppingCartFunctions";
import LookStylePopupButtons from "./lookStylePopupButtons";


const LookStylePopup = (props) => {

  const {lookOverlayOpened, setLookOverlayOpened, lookStylePopup, intl, isMobile} = props;

  const stylePopups = [LOOK_OVERLAYS.stylePairing, LOOK_OVERLAYS.styleColor, LOOK_OVERLAYS.styleRemove, LOOK_OVERLAYS.styleRemoveBack, LOOK_OVERLAYS.styleRemoveFeature];
  if (!lookOverlayOpened || !stylePopups.some(popupType => popupType === lookOverlayOpened)) {
    return null
  }

  const {notMatchingFeatures} = lookStylePopup;

  const closePopup = (hideOverlay) => {
    hideOverlay(() => {
      setLookOverlayOpened("");
    })
  }

  let stylePrefix = "";
  switch (lookOverlayOpened) {
    case LOOK_OVERLAYS.stylePairing: {
      stylePrefix = "pairing";
      break;
    }
    case LOOK_OVERLAYS.styleColor: {
      stylePrefix = "color";
      break;
    }
    case LOOK_OVERLAYS.styleRemove: {
      stylePrefix = "remove";
      break;
    }
    case LOOK_OVERLAYS.styleRemoveBack: {
      stylePrefix = "removeBack";
      break;
    }
    case LOOK_OVERLAYS.styleRemoveFeature: {
      stylePrefix = "removeFeature";
      break;
    }
  }

  return (
    <WithOverlay className="look-overlay--style">
      {(hideOverlay) => (
        <div className={"look-popup look-popup--style"
        + ((lookOverlayOpened === LOOK_OVERLAYS.stylePairing) && notMatchingFeatures.length
          ? " look-overlay--features-"+notMatchingFeatures.length
          : "")}>
          <div className="look-popup__title">
            <h2 className="look-popup__title-text look-popup__title-text--with-icon h2 h2--regular">
              <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})} disabled={true}
                          className="look-icon look-icon--small look-icon--yellow look-icon--disabled">
                <ErrorIcon/>
              </IconButton>
              <span className="look-popup__content-title-text"><FormattedMessage id="overlays.style.title"/></span>
              <span className="look-popup__content-title-dash"> - </span>
              <strong><FormattedMessage id={`overlays.style.${stylePrefix}.title`}/></strong>
            </h2>
            {isMobile ? (
              <div className="look-popup__title-actions">
                <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                            className="look-icon look-icon--small"
                            onClick={() => closePopup(hideOverlay)}>
                  <CloseIcon/>
                </IconButton>
              </div>
            ) : null}
          </div>
          <div className="look-popup__content text-left">
            <p className="text text-left">
              <FormattedMessage id={`overlays.style.${stylePrefix}.text`}/>
            </p>
            {notMatchingFeatures.length ? (
              <ul className="lm-features lm-features--type-1">
                {notMatchingFeatures.map(notMatchingFeature => {
                  return <LookStylePopupFeature key={notMatchingFeature.dbFeature.id}
                                                lookFeature={notMatchingFeature} />
                })}
              </ul>
            ) : null}
            <p className="h3 look-popup__content-subtitle">
              <FormattedMessage id={`overlays.style.${stylePrefix}.subText`}/>
            </p>
          </div>
          <LookStylePopupButtons closePopup={() => closePopup(hideOverlay)}/>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened, lookStylePopup, lookActiveFeature} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookOverlayOpened,
    lookStylePopup,
    lookActiveFeature,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookStylePopup,
  setLookActiveCategory,
  setLookPageOpened,
  removeFromCart,
  setLookRemovedCartItems,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookStylePopup)
  )
)
